<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <div class=" text-h4 ma-4" v-show="!showSkeleton">Atualizar Perfil - {{ nome }}</div>

    <div v-if="canRender">
      <CadastroPerfil edicao="true" :id="id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import rolesStore from '../_store'

import CadastroPerfil from './CadastroPerfil'

export default {
  name: 'AtualizarPerfil',
  props: {
    id: String,
  },
  components: { CadastroPerfil, SkeletonLoaderTitleUpdate },

  data: () => ({
    nome: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarPerfilModuleUsersStore', ['getSpecificRole']),
  },

  async created() {
    
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarPerfilModuleUsersStore', rolesStore)
    await this.listSpecificRole(this.id)
    this.nome = this.getSpecificRole.name

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarPerfilModuleUsersStore', ['listSpecificRole']),
  },
}
</script>
